// DigiCS, the website chat's bot (#284 B4): the prepared answers editor and the settings page (only where the API has the chat).
export const digicsEn = {
  'digics.answers.title': 'DigiCS answers',
  'digics.answers.subtitle': 'The prepared answers DigiCS sends in the website chat. A model only picks one; visitors see exactly the text written here. Changes reach the chat within a minute.',
  'digics.answers.add': 'Add answer',
  'digics.answers.search': 'Search code, text or "when it fits"',
  'digics.answers.empty': 'No answers found',
  'digics.answers.emptyHint': 'Try another word.',
  'digics.answers.count': '{shown} of {total} answers (at most {max}).',
  'digics.col.code': 'Code',
  'digics.col.text': 'Indonesian text',
  'digics.col.when': 'When it fits',
  'digics.col.status': 'Status',
  'digics.col.updated': 'Last saved',
  'digics.kind.answer': 'Answer',
  'digics.kind.handover': 'Hand-over',
  'digics.kind.greeting': 'Greeting',
  'digics.kind.offtopic': 'Off topic',
  'digics.kind.bot_identity': 'About the bot',
  'digics.kindHint.answer': 'DigiCS sends the text and the chat goes on.',
  'digics.kindHint.handover': 'DigiCS sends the text and passes the chat to the team. No emoji in hand-over texts.',
  'digics.protected': 'Sent by the hand-over itself, so it can be edited but not switched off.',
  'digics.protectedShort': 'Always on',
  'digics.active': 'On',
  'digics.inactive': 'Off',
  'digics.seed': 'From the start',
  'digics.edit': 'Edit',
  'digics.editTitle': 'Answer "{code}"',
  'digics.lastSaved': 'Last saved {date} by {name}.',
  'digics.neverSaved': 'Not changed since the start.',
  'digics.reachNote': 'Saved changes reach the chat within a minute.',
  'digics.rule.empty': 'Write the text first.',
  'digics.rule.tooLong': 'At most {max} characters.',
  'digics.rule.banned': '"{word}" is not allowed in a chat answer.',
  'digics.rule.price': 'No prices in a chat answer: link to the packages page instead.',
  'digics.rule.noEmoji': 'No emoji in a hand-over answer.',
  'digics.rule.emoji': 'At most {max} emoji in one answer.',
  'digics.rulesNote': 'House rules, checked on save: no prices, nothing "built with AI", no "source code", no "unlimited", no WhatsApp, no formal Indonesian ("Dengan hormat", "Adapun"), at most 1 emoji (none in a hand-over).',
  'digics.codeInvalid': 'Use 2–40 lowercase letters, digits or _, starting with a letter.',
  'digics.saved': 'Saved. The chat uses it within a minute.',
  'digics.refused': 'Not saved:',
  'digics.field.code': 'Code',
  'digics.field.codeHint': 'For example payment_terms. It can\'t be changed later.',
  'digics.field.kind': 'Kind',
  'digics.field.textId': 'Indonesian text',
  'digics.field.textEn': 'English text',
  'digics.field.textEnHint': 'Visitors in English, Chinese, Vietnamese and Japanese see this text.',
  'digics.field.when': 'When it fits',
  'digics.field.whenHint': 'One sentence, in English, that tells the model when to pick this answer. Visitors never see it.',
  'digics.field.active': 'On',
  'digics.field.activeHint': 'Off: DigiCS never picks it. Nothing is deleted.',
  'digics.preview.title': 'How it looks in the chat',
  'digics.preview.note': 'Paths like /layanan/ become links in the chat.',
  'digics.preview.visitor': 'Halo!',
  'digics.preview.empty': '(no text yet)',

  'digics.settings.title': 'DigiCS settings',
  'digics.settings.subtitle': 'How DigiCS answers, its monthly cost cap, staff hours and the Telegram alert. Changes reach the chat within a minute.',
  'digics.usage.title': 'Usage this month ({month})',
  'digics.usage.provider': 'Provider',
  'digics.usage.calls': 'Calls',
  'digics.usage.cost': 'Booked cost',
  'digics.usage.total': 'Booked: {used}',
  'digics.usage.cap': 'Cap: {cap}',
  'digics.usage.bar': '{pct}% of the monthly cap used',
  'digics.usage.note': 'Every model call is booked at the cost per call below before it is made, so the cap is a hard ceiling. The real bill is usually lower: compare with the provider\'s dashboard.',
  'digics.live.unreachable': 'The website chat could not be reached just now.',
  'digics.secrets.notSet': 'Not set',
  'digics.siteOff': 'The chat is switched off on the website (LIVE_CHAT), so these settings are not used yet.',
  'digics.provider.haiku': 'Claude Haiku (Anthropic)',
  'digics.provider.gemini': 'Gemini Flash (Google)',
  'digics.section.behaviour': 'How DigiCS answers',
  'digics.section.behaviourHint': 'The model only picks one of the prepared answers. When it is unsure, the chat goes to a person.',
  'digics.section.cost': 'Cost cap',
  'digics.section.costHint': 'In rupiah. When the month\'s booked cost would pass the cap, every chat goes to a person without a model call.',
  'digics.section.hours': 'Staff hours',
  'digics.section.hoursHint': 'Times in {tz}. Outside them the hand-over says the team replies on the next working day.',
  'digics.section.telegram': 'Telegram alert',
  'digics.section.telegramHint': 'When a chat needs a person, the team gets one Telegram message (no visitor email address in it).',
  'digics.field.mode': 'Mode',
  'digics.mode.off': 'Off',
  'digics.mode.suggest': 'Suggest',
  'digics.mode.auto': 'Auto',
  'digics.modeHint.off': 'Every message goes to a person. No model calls.',
  'digics.modeHint.suggest': 'DigiCS suggests an answer to the team only; the visitor is told the team will reply. Use this first.',
  'digics.modeHint.auto': 'DigiCS sends the prepared answer to the visitor.',
  'digics.field.provider': 'Provider',
  'digics.field.providerHint': 'Its key goes under Keys above (or in Cloudflare).',
  'digics.field.haikuModel': 'Claude model',
  'digics.field.geminiModel': 'Gemini model',
  'digics.model.recommended': 'recommended',
  'digics.model.other': 'Other…',
  'digics.model.id': 'Model id: {id}',
  'digics.model.otherId': 'Model id',
  'digics.model.otherHint': 'The exact id the provider gives, e.g. {example}. Check it with "Test the AI key".',
  'digics.model.note.cheapest': 'fast and cheapest',
  'digics.model.note.newest': 'newest, smarter, costs more',
  'digics.model.note.smarter': 'smarter, costs more',
  'digics.model.note.older': 'older, cheap',
  'digics.model.note.smartest': 'smartest, costs the most',
  'digics.field.minConfidence': 'Minimum confidence',
  'digics.field.minConfidenceHint': 'Between {min} and {max}. Below it the chat goes to a person.',
  'digics.field.maxCalls': 'Model calls per chat',
  'digics.field.maxCallsHint': 'At most {max}. After that the chat goes to a person.',
  'digics.field.cap': 'Monthly cap (Rp)',
  'digics.field.capHint': 'At most {max}.',
  'digics.field.costHaiku': 'Cost per Claude call (Rp)',
  'digics.field.costGemini': 'Cost per Gemini call (Rp)',
  'digics.field.costHint': 'What each call is booked at against the cap.',
  'digics.field.days': 'Staff days',
  'digics.day.1': 'Mon',
  'digics.day.2': 'Tue',
  'digics.day.3': 'Wed',
  'digics.day.4': 'Thu',
  'digics.day.5': 'Fri',
  'digics.day.6': 'Sat',
  'digics.day.7': 'Sun',
  'digics.field.start': 'From',
  'digics.field.end': 'Until',
  'digics.field.chatId': 'Telegram chat id',
  'digics.field.chatIdHint': 'A number (groups start with -) or @channelname. Empty: no alerts.',
  'digics.test.button': 'Send test alert',
  'digics.test.sending': 'Sending…',
  'digics.test.sent': 'Test alert sent. Check Telegram for "DigiCS test alert".',
  'digics.test.no_token': 'No Telegram bot token yet. Enter it under Keys.',
  'digics.test.no_chat_id': 'Save a Telegram chat id first.',
  'digics.test.failed': 'Telegram refused the message. Check the chat id and that the bot is in that chat.',
  'digics.test.needChatId': 'Save a chat id to send a test alert.',
  'digics.test.needToken': 'Enter the Telegram bot token under Keys to send a test alert.',
  'digics.test.what': 'Sends one message, "DigiCS test alert", to the saved chat id.',
  'digics.keys.title': "Keys",
  'digics.keys.hint': "The chat's AI and Telegram keys. A key entered here is stored sealed and wins over the website's Cloudflare secret of the same name. Nobody can read it back: you can only replace or remove it.",
  'digics.keys.adminOnly': "Only admins can enter, replace or remove keys.",
  'digics.keys.name.ANTHROPIC_API_KEY': "Anthropic API key (Claude Haiku)",
  'digics.keys.name.GEMINI_API_KEY': "Gemini API key (Gemini Flash)",
  'digics.keys.name.DIGICS_TELEGRAM_TOKEN': "Telegram bot token",
  'digics.keys.placeholder.ANTHROPIC_API_KEY': "sk-ant-…",
  'digics.keys.placeholder.GEMINI_API_KEY': "AQ.… / AIza…",
  'digics.keys.placeholder.DIGICS_TELEGRAM_TOKEN': "123456789:AA…",
  'digics.keys.paste': "Paste the key",
  'digics.keys.newValue': "New key",
  'digics.keys.overrides': "Once saved here, the chat uses this key instead of the Cloudflare secret (within a minute).",
  'digics.keys.setInCms': "Set in CMS ••••{last4}",
  'digics.keys.setInCloudflare': "Set in Cloudflare",
  'digics.keys.unknown': "Not in CMS (website not reachable)",
  'digics.keys.replace': "Replace",
  'digics.keys.remove': "Remove",
  'digics.keys.removeTitle': "Remove the {name}?",
  'digics.keys.removeBody': "The chat stops using it within a minute. If the same key is set in Cloudflare, the chat goes back to that one.",
  'digics.keys.saved': "Key saved. The chat uses it within a minute.",
  'digics.keys.removed': "Key removed.",
  'digics.testKey.button': "Test the AI key ({provider})",
  'digics.testKey.testing': "Testing…",
  'digics.testKey.ok': "The {provider} key works.",
  'digics.testKey.no_key': "No key for this provider yet. Enter one above.",
  'digics.testKey.key_refused': "The provider refused the key. Check it and enter it again.",
  'digics.testKey.model_not_found': "Model not found. Check the model id under \"How DigiCS answers\".",
  'digics.testKey.network': "Could not reach the provider. Try again.",
  'digics.testKey.month_cap': "This month's cost cap is reached, so no test was sent.",
  'digics.testKey.no_bank': "The chat could not load its prepared answers. Try again.",
  'digics.testKey.failed': "The test failed. Try again in a minute.",
  'digics.testKey.tried': "{what}{status} for {model}",
  'digics.testKey.short.key_refused': "Key refused",
  'digics.testKey.short.model_not_found': "Model not found",
  'digics.testKey.short.network': "No answer",
  'digics.testKey.short.failed': "Provider error",
  'digics.testKey.what': "Sends one tiny request (\"halo\") with the chosen provider's key. It counts as one call in this month's cost.",
  'digics.findChat.button': "Find chat id",
  'digics.findChat.finding': "Looking…",
  'digics.findChat.what': "Lists the chats that wrote to your bot lately. Pick one to get the alerts there.",
  'digics.findChat.needToken': "Enter the Telegram bot token under Keys first.",
  'digics.findChat.list': "Chats that wrote to the bot",
  'digics.findChat.none': "Send your bot a message first, then try again.",
  'digics.findChat.no_token': "Enter the Telegram bot token under Keys first.",
  'digics.findChat.bad_token': "Telegram does not know this token. Check it with @BotFather.",
  'digics.findChat.webhook': "This bot uses a webhook, so Telegram can't list its chats. Type the chat id by hand.",
  'digics.findChat.network': "Could not reach Telegram. Try again.",
  'digics.findChat.failed': "Telegram did not answer as expected. Try again.",
  'digics.findChat.use': "Use this chat",
  'digics.findChat.current': "In use",
  'digics.findChat.noName': "(no name)",
  'digics.findChat.saved': "Alerts now go to chat {id}.",
  'digics.findChat.type.private': "Private chat",
  'digics.findChat.type.group': "Group",
  'digics.findChat.type.supergroup': "Group",
  'digics.findChat.type.channel': "Channel",
  'digics.findChat.type.other': "Chat",
} as const

export const digicsId: Record<keyof typeof digicsEn, string> = {
  'digics.answers.title': 'Jawaban DigiCS',
  'digics.answers.subtitle': 'Jawaban siap pakai yang dikirim DigiCS di chat website. Model hanya memilih salah satunya; pengunjung melihat persis teks yang ditulis di sini. Perubahan sampai ke chat dalam satu menit.',
  'digics.answers.add': 'Tambah jawaban',
  'digics.answers.search': 'Cari kode, teks, atau "kapan cocok"',
  'digics.answers.empty': 'Jawaban tidak ditemukan',
  'digics.answers.emptyHint': 'Coba kata lain.',
  'digics.answers.count': '{shown} dari {total} jawaban (maksimal {max}).',
  'digics.col.code': 'Kode',
  'digics.col.text': 'Teks Indonesia',
  'digics.col.when': 'Kapan cocok',
  'digics.col.status': 'Status',
  'digics.col.updated': 'Terakhir disimpan',
  'digics.kind.answer': 'Jawaban',
  'digics.kind.handover': 'Serah ke tim',
  'digics.kind.greeting': 'Sapaan',
  'digics.kind.offtopic': 'Di luar topik',
  'digics.kind.bot_identity': 'Tentang bot',
  'digics.kindHint.answer': 'DigiCS mengirim teksnya dan chat lanjut.',
  'digics.kindHint.handover': 'DigiCS mengirim teksnya lalu menyerahkan chat ke tim. Teks serah ke tim tanpa emoji.',
  'digics.protected': 'Dikirim otomatis saat chat diserahkan ke tim, jadi bisa diubah tapi tidak bisa dimatikan.',
  'digics.protectedShort': 'Selalu aktif',
  'digics.active': 'Aktif',
  'digics.inactive': 'Mati',
  'digics.seed': 'Bawaan awal',
  'digics.edit': 'Ubah',
  'digics.editTitle': 'Jawaban "{code}"',
  'digics.lastSaved': 'Terakhir disimpan {date} oleh {name}.',
  'digics.neverSaved': 'Belum pernah diubah.',
  'digics.reachNote': 'Perubahan yang disimpan sampai ke chat dalam satu menit.',
  'digics.rule.empty': 'Tulis teksnya dulu.',
  'digics.rule.tooLong': 'Maksimal {max} karakter.',
  'digics.rule.banned': '"{word}" tidak boleh ada di jawaban chat.',
  'digics.rule.price': 'Jangan tulis harga di jawaban chat: tautkan ke halaman paket.',
  'digics.rule.noEmoji': 'Jawaban serah ke tim tidak boleh pakai emoji.',
  'digics.rule.emoji': 'Maksimal {max} emoji per jawaban.',
  'digics.rulesNote': 'Aturan kami, dicek saat menyimpan: tanpa harga, tanpa "built with AI", tanpa "source code", tanpa "unlimited", tanpa WhatsApp, tanpa bahasa kaku ("Dengan hormat", "Adapun"), maksimal 1 emoji (tanpa emoji untuk serah ke tim).',
  'digics.codeInvalid': 'Pakai 2–40 huruf kecil, angka, atau _, diawali huruf.',
  'digics.saved': 'Tersimpan. Chat memakainya dalam satu menit.',
  'digics.refused': 'Belum tersimpan:',
  'digics.field.code': 'Kode',
  'digics.field.codeHint': 'Misalnya payment_terms. Tidak bisa diubah nanti.',
  'digics.field.kind': 'Jenis',
  'digics.field.textId': 'Teks Indonesia',
  'digics.field.textEn': 'Teks Inggris',
  'digics.field.textEnHint': 'Pengunjung berbahasa Inggris, Mandarin, Vietnam, dan Jepang melihat teks ini.',
  'digics.field.when': 'Kapan cocok',
  'digics.field.whenHint': 'Satu kalimat dalam bahasa Inggris yang memberi tahu model kapan memilih jawaban ini. Pengunjung tidak pernah melihatnya.',
  'digics.field.active': 'Aktif',
  'digics.field.activeHint': 'Mati: DigiCS tidak pernah memilihnya. Tidak ada yang dihapus.',
  'digics.preview.title': 'Tampilannya di chat',
  'digics.preview.note': 'Alamat seperti /layanan/ jadi tautan di chat.',
  'digics.preview.visitor': 'Halo!',
  'digics.preview.empty': '(belum ada teks)',

  'digics.settings.title': 'Pengaturan DigiCS',
  'digics.settings.subtitle': 'Cara DigiCS menjawab, batas biaya bulanan, jam kerja tim, dan notifikasi Telegram. Perubahan sampai ke chat dalam satu menit.',
  'digics.usage.title': 'Pemakaian bulan ini ({month})',
  'digics.usage.provider': 'Penyedia',
  'digics.usage.calls': 'Panggilan',
  'digics.usage.cost': 'Biaya tercatat',
  'digics.usage.total': 'Tercatat: {used}',
  'digics.usage.cap': 'Batas: {cap}',
  'digics.usage.bar': '{pct}% dari batas bulanan terpakai',
  'digics.usage.note': 'Setiap panggilan model dicatat dengan biaya per panggilan di bawah sebelum dijalankan, jadi batasnya benar-benar batas. Tagihan aslinya biasanya lebih kecil: bandingkan dengan dashboard penyedia.',
  'digics.live.unreachable': 'Chat website sedang tidak bisa dihubungi.',
  'digics.secrets.notSet': 'Belum diisi',
  'digics.siteOff': 'Chat sedang dimatikan di website (LIVE_CHAT), jadi pengaturan ini belum dipakai.',
  'digics.provider.haiku': 'Claude Haiku (Anthropic)',
  'digics.provider.gemini': 'Gemini Flash (Google)',
  'digics.section.behaviour': 'Cara DigiCS menjawab',
  'digics.section.behaviourHint': 'Model hanya memilih salah satu jawaban siap pakai. Kalau ragu, chat diserahkan ke orang.',
  'digics.section.cost': 'Batas biaya',
  'digics.section.costHint': 'Dalam rupiah. Kalau biaya tercatat bulan ini bakal melewati batas, semua chat diserahkan ke orang tanpa memanggil model.',
  'digics.section.hours': 'Jam kerja tim',
  'digics.section.hoursHint': 'Waktu {tz}. Di luar jam ini, pesan serah ke tim bilang tim membalas di hari kerja berikutnya.',
  'digics.section.telegram': 'Notifikasi Telegram',
  'digics.section.telegramHint': 'Kalau chat perlu dijawab orang, tim dapat satu pesan Telegram (tanpa alamat email pengunjung).',
  'digics.field.mode': 'Mode',
  'digics.mode.off': 'Mati',
  'digics.mode.suggest': 'Saran',
  'digics.mode.auto': 'Otomatis',
  'digics.modeHint.off': 'Semua pesan diserahkan ke orang. Model tidak dipanggil.',
  'digics.modeHint.suggest': 'DigiCS hanya menyarankan jawaban ke tim; pengunjung diberi tahu tim akan membalas. Pakai ini dulu.',
  'digics.modeHint.auto': 'DigiCS langsung mengirim jawaban siap pakai ke pengunjung.',
  'digics.field.provider': 'Penyedia',
  'digics.field.providerHint': 'Kuncinya diisi di bagian Kunci di atas (atau di Cloudflare).',
  'digics.field.haikuModel': 'Model Claude',
  'digics.field.geminiModel': 'Model Gemini',
  'digics.model.recommended': 'disarankan',
  'digics.model.other': 'Lainnya…',
  'digics.model.id': 'ID model: {id}',
  'digics.model.otherId': 'ID model',
  'digics.model.otherHint': 'ID persis dari provider, misalnya {example}. Cek dengan "Tes kunci AI".',
  'digics.model.note.cheapest': 'cepat dan paling murah',
  'digics.model.note.newest': 'paling baru, lebih pintar, lebih mahal',
  'digics.model.note.smarter': 'lebih pintar, lebih mahal',
  'digics.model.note.older': 'versi lama, murah',
  'digics.model.note.smartest': 'paling pintar, paling mahal',
  'digics.field.minConfidence': 'Keyakinan minimal',
  'digics.field.minConfidenceHint': 'Antara {min} dan {max}. Di bawah itu chat diserahkan ke orang.',
  'digics.field.maxCalls': 'Panggilan model per chat',
  'digics.field.maxCallsHint': 'Maksimal {max}. Setelah itu chat diserahkan ke orang.',
  'digics.field.cap': 'Batas bulanan (Rp)',
  'digics.field.capHint': 'Maksimal {max}.',
  'digics.field.costHaiku': 'Biaya per panggilan Claude (Rp)',
  'digics.field.costGemini': 'Biaya per panggilan Gemini (Rp)',
  'digics.field.costHint': 'Nilai yang dicatat per panggilan terhadap batas.',
  'digics.field.days': 'Hari kerja',
  'digics.day.1': 'Sen',
  'digics.day.2': 'Sel',
  'digics.day.3': 'Rab',
  'digics.day.4': 'Kam',
  'digics.day.5': 'Jum',
  'digics.day.6': 'Sab',
  'digics.day.7': 'Min',
  'digics.field.start': 'Mulai',
  'digics.field.end': 'Sampai',
  'digics.field.chatId': 'ID chat Telegram',
  'digics.field.chatIdHint': 'Angka (grup diawali -) atau @namachannel. Kosong: tidak ada notifikasi.',
  'digics.test.button': 'Kirim notifikasi uji',
  'digics.test.sending': 'Mengirim…',
  'digics.test.sent': 'Notifikasi uji terkirim. Cek Telegram untuk "DigiCS test alert".',
  'digics.test.no_token': 'Token bot Telegram belum ada. Isi di bagian Kunci.',
  'digics.test.no_chat_id': 'Simpan ID chat Telegram dulu.',
  'digics.test.failed': 'Telegram menolak pesannya. Cek ID chat dan pastikan bot sudah ada di chat itu.',
  'digics.test.needChatId': 'Simpan ID chat untuk mengirim notifikasi uji.',
  'digics.test.needToken': 'Isi token bot Telegram di bagian Kunci untuk mengirim notifikasi uji.',
  'digics.test.what': 'Mengirim satu pesan, "DigiCS test alert", ke ID chat yang tersimpan.',
  'digics.keys.title': "Kunci",
  'digics.keys.hint': "Kunci AI dan Telegram untuk chat. Kunci yang diisi di sini disimpan terenkripsi dan dipakai duluan, menggantikan secret Cloudflare dengan nama yang sama. Kuncinya tidak bisa dibaca lagi, cuma bisa diganti atau dihapus.",
  'digics.keys.adminOnly': "Cuma admin yang bisa mengisi, mengganti, atau menghapus kunci.",
  'digics.keys.name.ANTHROPIC_API_KEY': "Kunci API Anthropic (Claude Haiku)",
  'digics.keys.name.GEMINI_API_KEY': "Kunci API Gemini (Gemini Flash)",
  'digics.keys.name.DIGICS_TELEGRAM_TOKEN': "Token bot Telegram",
  'digics.keys.placeholder.ANTHROPIC_API_KEY': "sk-ant-…",
  'digics.keys.placeholder.GEMINI_API_KEY': "AQ.… / AIza…",
  'digics.keys.placeholder.DIGICS_TELEGRAM_TOKEN': "123456789:AA…",
  'digics.keys.paste': "Tempel kuncinya",
  'digics.keys.newValue': "Kunci baru",
  'digics.keys.overrides': "Setelah disimpan di sini, chat memakai kunci ini, bukan secret Cloudflare (paling lama semenit).",
  'digics.keys.setInCms': "Ada di CMS ••••{last4}",
  'digics.keys.setInCloudflare': "Ada di Cloudflare",
  'digics.keys.unknown': "Tidak ada di CMS (website tidak bisa dihubungi)",
  'digics.keys.replace': "Ganti",
  'digics.keys.remove': "Hapus",
  'digics.keys.removeTitle': "Hapus {name}?",
  'digics.keys.removeBody': "Chat berhenti memakainya dalam semenit. Kalau kunci yang sama ada di Cloudflare, chat kembali memakai yang itu.",
  'digics.keys.saved': "Kunci tersimpan. Chat memakainya dalam semenit.",
  'digics.keys.removed': "Kunci dihapus.",
  'digics.testKey.button': "Tes kunci AI ({provider})",
  'digics.testKey.testing': "Mengetes…",
  'digics.testKey.ok': "Kunci {provider} jalan.",
  'digics.testKey.no_key': "Belum ada kunci untuk provider ini. Isi dulu di atas.",
  'digics.testKey.key_refused': "Provider menolak kuncinya. Cek lalu isi lagi.",
  'digics.testKey.model_not_found': "Model tidak ditemukan. Cek ID model di \"Cara DigiCS menjawab\".",
  'digics.testKey.network': "Provider tidak bisa dihubungi. Coba lagi.",
  'digics.testKey.month_cap': "Batas biaya bulan ini sudah tercapai, jadi tes tidak dikirim.",
  'digics.testKey.no_bank': "Chat belum bisa memuat jawaban siap pakainya. Coba lagi.",
  'digics.testKey.failed': "Tesnya gagal. Coba lagi semenit lagi.",
  'digics.testKey.tried': "{what}{status} untuk {model}",
  'digics.testKey.short.key_refused': "Kunci ditolak",
  'digics.testKey.short.model_not_found': "Model tidak ditemukan",
  'digics.testKey.short.network': "Tidak ada jawaban",
  'digics.testKey.short.failed': "Error dari provider",
  'digics.testKey.what': "Mengirim satu permintaan kecil (\"halo\") dengan kunci provider yang dipilih. Dihitung satu panggilan di biaya bulan ini.",
  'digics.findChat.button': "Cari ID chat",
  'digics.findChat.finding': "Mencari…",
  'digics.findChat.what': "Menampilkan chat yang baru-baru ini mengirim pesan ke bot kamu. Pilih satu supaya notifikasi masuk ke sana.",
  'digics.findChat.needToken': "Isi token bot Telegram di bagian Kunci dulu.",
  'digics.findChat.list': "Chat yang mengirim pesan ke bot",
  'digics.findChat.none': "Kirim pesan ke bot kamu dulu, lalu coba lagi.",
  'digics.findChat.no_token': "Isi token bot Telegram di bagian Kunci dulu.",
  'digics.findChat.bad_token': "Telegram tidak mengenali token ini. Cek di @BotFather.",
  'digics.findChat.webhook': "Bot ini memakai webhook, jadi Telegram tidak bisa menampilkan chat-nya. Ketik ID chat secara manual.",
  'digics.findChat.network': "Telegram tidak bisa dihubungi. Coba lagi.",
  'digics.findChat.failed': "Jawaban Telegram tidak sesuai. Coba lagi.",
  'digics.findChat.use': "Pakai chat ini",
  'digics.findChat.current': "Dipakai",
  'digics.findChat.noName': "(tanpa nama)",
  'digics.findChat.saved': "Notifikasi sekarang masuk ke chat {id}.",
  'digics.findChat.type.private': "Chat pribadi",
  'digics.findChat.type.group': "Grup",
  'digics.findChat.type.supergroup': "Grup",
  'digics.findChat.type.channel': "Kanal",
  'digics.findChat.type.other': "Chat",
}
